module.exports = __webpack_public_path__ + "static/img/Jeremy_Cameron_mobile.88b27ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy_Cameron_mobile.jpg
// module id = dEr+
// module chunks = 0